// Missing or invalid dates belong after dated orders.
const timestamp = order => {
  if (!order.date) return -Infinity;
  const value = new Date(order.date).getTime();
  return Number.isNaN(value) ? -Infinity : value;
};

export const newestOrderFirst = (a, b) => {
  const first = timestamp(a);
  const second = timestamp(b);
  if (first !== second) return first > second ? -1 : 1;
  return String(b.timeCreated || '').localeCompare(String(a.timeCreated || ''), undefined, { numeric: true });
};
